import React from "react";
import "./StepFive.style.scss";

export default function StepFive() {
    return <div className="step_five_scammer">
        <div className="wrapper_text">
            <p>Що робити у випадку, якщо ви натрапили на шахрая</p>
            <label>1. Якщо ви стикнулися з шахрайством у сервісі OLX Доставка, напишіть їм у чат з поміткою «Шахрайство
                в OLX доставка». Повідомте: номер/посилання на оголошення шахрая на OLX; де ви знайшли оголошення
                продавця (в додатку версії Android чи IOS, повній версії сайті чи мобільній); телефон, вказаний в
                оголошенні.<br/><br/>
                2. Якщо ви випадково розкрили дані платіжної картки шахрая, негайно зверніться на гарячу лінію вашого
                банку за телефоном, вказаним на звороті картки.<br/><br/>
                3. Якщо є контакти шахрая, яка намагалася дізнатися конфіденційну інформацію або надіслала вам
                небезпечне посилання, передайте цю інформацію в Кіберполіцію за посиланням або зателефонувавши за
                номером 0 800 505 170.<br/>
            </label>
        </div>
    </div>
}